(function ($) {
    'use strict';

    var classCollapsed = 'ln-collapsed',
        generateId = window.dk.generateId;

    function getButtonTitleAndLabel($item, isCollapsed) {
        var pageName = $item.text().replace(/\s{2,}/ig, ' '),
            isGroup = $item.parents('.ln-group').length > 0,
            label, title;
        isCollapsed = typeof isCollapsed === 'boolean' ?
            isCollapsed : $item.parents('li:first').is(classCollapsed);
        label = isCollapsed ? 'Show' : 'Hide';
        title = label +
            (isGroup ? ' ' : ' child pages for ') +
            pageName +
            (isGroup ? ' pages' : '');
        return { l: label, t: title };
    }

    // Document ready
    $(function () {

        var longTouch = true;
        var scrollTop = 0;

        $('.dk-leftnav').each(function () {
            var $ctr = $(this),
                $parents = $('> ul > li', $ctr).filter(function () {
                    return $(this).find('ul').length > 0;
                });
            if ($parents.length > 0) {
                if ($parents.filter(':not(.ln-group)').length > 0) {
                    $('> ul', $ctr).addClass('ln-expandable');
                }
                $parents.each(function () {
                    var $li = $(this),
                        $item = $('>:first', $li),
                        ulId = generateId('ln-ul-'),
                        isGroup = $li.is('.ln-group'),
                        isCurrent = $li.is('.ln-current'),
                        isDefaultExpanded = isGroup || $li.is('.ln-default-expanded'),
                        isCollapsed = !isCurrent && !isDefaultExpanded,
                        titleLabel = getButtonTitleAndLabel($item, isCollapsed),
                        $button = $('<button type="button"/>').attr({
                            'title': titleLabel.t,
                            'aria-label': titleLabel.l,
                            'aria-controls': ulId,
                            'aria-expanded': isCollapsed ? null : 'true'
                        }).html(isGroup ? $item.html() : ''),
                        $div = $('<div/>').append(
                            isGroup ? null : $item,
                            $button
                        );
                    $li.prepend($div);
                    if (isGroup) {
                        $item.remove();
                    }
                    $('ul', $li).attr('id', ulId);
                    if (isCollapsed) {
                        $li.addClass(classCollapsed);
                    }
                    $button.on('click', function (e) {
                        var $btn = $(this),
                            $l = $btn.parents('li:first'),
                            $ul = $('ul', $l),
                            isColl = $l.hasClass(classCollapsed);
                        e.preventDefault();
                        $ul[isColl ? 'slideDown' : 'slideUp'](300, function () {
                            var isC = $li.toggleClass(classCollapsed).hasClass(classCollapsed),
                                btnTitleLabel = getButtonTitleAndLabel(isGroup ? $btn : $item, isC);
                            $btn.attr({
                                'title': btnTitleLabel.t,
                                'aria-label': btnTitleLabel.l,
                                'aria-expanded': isC ? null : 'true'
                            });
                        });
                        return false;
                    });
                });
            }
        });

        $('nav').on('touchstart', function () {
            if ($(this).hasClass('dk-leftnav related')) {
                event.stopPropagation();
            }
        });

        // Contextual drop-down menu for mobile
        $('.context-menu-button').on('click', function () {
            $('.dk-leftnav').toggleClass('related');
            $('.context-menu-button').toggleClass('open');
        });

        /* checks if touch is shorter than 200ms and window has scrolled less than 3 pixels */
        $('.site-wrap').on('touchstart', function () {
            setTimeout(function () { longTouch = true; }, 200);
            longTouch = false;
            scrollTop = $(window).scrollTop();
        });

        $('.site-wrap').on('click touchend', function () {
            if ((longTouch === false) && (Math.abs($(window).scrollTop() - scrollTop) < 3)) {
                $('.dk-leftnav').removeClass('related');
                $('.context-menu-button').removeClass('open');
                longTouch = true;
            } else {
                longTouch = true;
            }
        });

        $('.context-menu-button').on('click touchstart touchend', function (event) {
            event.stopPropagation();
        });

        $('button[name="options"], button.mobile-site-search, button.dk-nav-menu').on('click', function () {
            $('.dk-leftnav').removeClass('related');
            $('.context-menu-button').removeClass('open');
        });



    });
})(window.jQuery);
